import React from "react";

import EmailAttachmentsGrid from "./EmailAttachmentsGrid";

interface RightColumnProps {
  hashValue: string;
  sourceID: number | undefined;
  relationshipID: number;
  attachmentsRoute: string;
}

const RightEmailColumn: React.FC<RightColumnProps> = ({
  hashValue,
  sourceID,
  relationshipID,
  attachmentsRoute
}) => (
  <section className="flex flex-column flex-gap-2 width-50-pc overflow-hidden">
    <EmailAttachmentsGrid
      hashValue={hashValue}
      sourceID={sourceID}
      relationshipID={relationshipID}
      attachmentsRoute={attachmentsRoute}
    />
  </section>
);

export default RightEmailColumn;
